var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Registrants',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"table.item.action",fn:function(slotProps){return [_c('ProgressBackwardItemAction',_vm._g(_vm._b({},'ProgressBackwardItemAction',slotProps,false),slotProps.on))]}}])},'Registrants',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }